export default "__VITE_ASSET__D27TL6vR__"